import { Component, inject } from '@angular/core';
import { PositionsFacade } from '@zero/shared/util-global-state';
import { OrdersComponent } from '../../components/orders/orders.component';

@Component({
  selector: 'order-my-orders',
  templateUrl: './my-orders.component.html',
  imports: [OrdersComponent],
})
export class MyOrdersComponent {
  public readonly positionsFacade = inject(PositionsFacade);

  public reloadPositions(): void {
    this.positionsFacade.loadPositions(true);
  }
}
